import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { hasCashback } from '../../../../services/partner/utils';

import CashbackBlocPartenaireComponent from '../../../partner/CashbackBlocPartenaireComponent';

import './CashbackOfferComponent.scss';

export const CashbackOfferComponent = connect(state => ({ CASHBACK: state.i18n.common.CASHBACK }))(
    ({ partner, CASHBACK, withCoupon, discount }) => {
        if (partner) {
            return (
                <div className="offer-cashback flex-container-v flex-center">
                    {withCoupon && hasCashback(partner) && (
                        <p className="color2 uppercase bold">{CASHBACK}</p>
                    )}
                    <CashbackBlocPartenaireComponent
                        partner={partner}
                        cssClassContainer={`offer-cashback-container ${
                            withCoupon ? 'flex-container-v flex-center coupon' : 'margin-child'
                        }`}
                        discount={discount}
                    />
                </div>
            );
        }
        return null;
    }
);

CashbackOfferComponent.propTypes = {
    partner: PropTypes.object.isRequired,
    withCoupon: PropTypes.bool,
    discount: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/components/pages/interstitiel/offer/CashbackOfferComponent.js